import { render, staticRenderFns } from "./CarouselItemsOfertHorizontal.vue?vue&type=template&id=eaa68b30"
import script from "./CarouselItemsOfertHorizontal.vue?vue&type=script&lang=js"
export * from "./CarouselItemsOfertHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports